export interface PopinConfirmationState {
	open: boolean,
	date: string
}

export const INITIAL_POPIN_CONFIRMATION: PopinConfirmationState = {
	open: false,
	date: ''
}

export interface PopinErreurConfirmationState {
	open: boolean,
	error_id: string
}

export const INITIAL_POPIN_ERREUR_CONFIRMATION: PopinErreurConfirmationState = {
	open: false,
	error_id: ''
}